import RouterStore from '@/store/RouterStore';
import config from '../misc/Configuracao';
import { IParametrosUsuario } from '../modelo/Parametros';
import UsuarioStore from '../store/UsuarioStore';
import fetch from './AxiosAdapter';
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

export class ParametroUsuarioApi {

    static parametrosMock = [];

    async verificarResultado(result) {
        if (result.status >= 400) {
            if (apresentarApiErroPadrao(result?.data)) {
                throw result.data;
            }
            const erro = result.data;
            throw new Error(erro ? erro.mensagem : null);
        }
    }

    async salvar(parametro) {
        let result;
        try {
            result = await fetch(config.urlParametrosUsuario + '/' + parametro.numParametro + '/alterar',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: parametro.valor
                });
            await this.verificarResultado(result);
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível salvar o parâmetro. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }

        return result;
    }

    //MANTEM
    async excluir(parametro) {
        let result;
        try {
            let url = config.urlBaseGE + 'api/parametros/' + parametro.id;
            if (RouterStore.isPrd) {
                url = config.urlBaseMinuta + 'parametros/' + parametro.id;
            }

            result = await fetch(url,
                { method: 'DELETE' });
            await this.verificarResultado(result);
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível excluir o parâmetro. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }

        return result;

    }

    async todosParametros(): Promise<IParametrosUsuario[]> {
        let result;
        try {
            result = await fetch(config.urlParametrosUsuario + '/' + UsuarioStore.usuario.login + '/buscar/todos');
        } catch (error) {
            console.error(result);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro em sua solicitação. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
        if (result.status !== 200) {
            throw new Error('Não foi possível recuperar os parâmetros. Tente novamente.');
        }
        return result.data;
    }

    async criarPadrao() {
        let result;
        try {
            result = await fetch(config.urlParametrosUsuario + '/' + UsuarioStore.login + '/criar-padrao',
                {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                })
            return result;
        } catch (error) {
            console.error(result);
            if (apresentarApiErroPadrao(error)) {
                throw error;
            }
            throw new Error('Ocorreu um erro ao tentar criar padrão de parâmetros de usuário. Por favor, tente novamente. Caso persista comunique ao administrador do sistema.');
        }
    }

    async salvarSigla(sigla: string) {
        let result;
        try {
            result = await fetch(
                config.urlParametrosUsuario + '/' + UsuarioStore.usuario.login + '/salvar-sigla',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'text/plain'
                    },
                    body: sigla
                }
            );

            await this.verificarResultado(result);
            return result;
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            const message = "Não foi possível salvar a sigla. " + erro + " " + (result ? result.statusText : "");
            console.error(message);
            throw new Error(message);
        }
    }

}

export default new ParametroUsuarioApi();
